
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductMoldsEditor extends _Ext.ItemGridEditor<ProductMoldsRow> {
        protected getColumnsKey() { return 'OMS.ProductMolds'; }
        protected getDialogType() { return ProductMoldsDialog; }
        protected getIdProperty() { return ProductMoldsRow.idProperty; }
        protected getInsertPermission() { return ProductMoldsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductMoldsRow.localTextPrefix; }
        protected getService() { return ProductMoldsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}